import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component } from '@angular/core';
import { map } from 'rxjs';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NgClass, AsyncPipe, NgIf } from '@angular/common';
import { PrivacyTermsService } from '../../../../core/services/privacy-terms.service';
import { PrivacyPolicy } from '../../../../core/interfaces/privacy-terms.interface';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss'],
  standalone: true,
  imports: [NgClass, AsyncPipe, TranslateModule, NgIf],
})
export class PrivacyPolicyComponent {
  isMobile$ = this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small]).pipe(map((result) => result.matches));
  privacyPolicy!: PrivacyPolicy;

  constructor(private breakpointObserver: BreakpointObserver, private privacyTermsService: PrivacyTermsService, public tr: TranslateService) {
    this.privacyTermsService.getPrivacy().subscribe((res) => {
      this.privacyPolicy = res;
    });
  }
}
